




import Vue from 'vue'
import style from './style.module.scss'

import { PriceSettings } from '@/types/price-settings'

import cell from '@/components/root-components/product-price-setting/_common/cell.vue'

export default Vue.extend({
    name: 'price-cell',
    components: {
        cell
    },
    props: {
        data: {} as () => PriceSettings,
        typeCode: String
    },
    data() {
        return {
            style: style
        }
    },
    methods: {
        updateFromCell(data: number) {
            this.data.Price = data;

            this.$store.dispatch('fill', { typeCode: this.typeCode, row: this.data });
        }
    }
    
})
